import React from 'react';
import { Label } from 'reactstrap';

const CustomLabel = ({ htmlFor, children, isRequired }) => (
  <Label for={htmlFor}>
    {children}
    {isRequired && <span style={{ color: 'red' }}>*</span>}
  </Label>
);

export default CustomLabel;
